export default __webpack_public_path__ + "static/media/campaign-logo.3af535ff.svg";